export default function SectionHeader({
  title,
  className = "",
}: {
  title: string;
  className?: string;
}) {
  return (
    <div className="relative mb-10">
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-primary rounded-xl" />
      <h1 className={`ml-5 font-bold text-2xl ${className}`}>{title}</h1>
    </div>
  );
}
